import ErrorBoundaryWithLogger from './ErrorBoundaryWithLogger';

export default ErrorBoundaryWithLogger;
